const API_BASE = import.meta.env.VITE_API_BASE
  || import.meta.env.VITE_API_BASE_URL
  || 'https://u5aw5omfkd.execute-api.us-east-2.amazonaws.com/dev'

async function parseError(response) {
  const text = await response.text()

  if (!text) {
    return `Vendor portal API error: ${response.status}`
  }

  try {
    const payload = JSON.parse(text)
    return payload.error || `Vendor portal API error: ${response.status}`
  } catch (error) {
    return text
  }
}

function buildPortalQuery(params) {
  const url = new URL(`${API_BASE}/procurement/bids/vendor-portal/session`)

  for (const [key, value] of Object.entries(params || {})) {
    const normalized = String(value || '').trim()
    if (!normalized) {
      continue
    }

    url.searchParams.set(key, normalized)
  }

  return url
}

export async function fetchVendorPortalSession(params) {
  const response = await fetch(buildPortalQuery(params).toString())

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}

export async function prepareVendorPortalUpload(payload) {
  const response = await fetch(`${API_BASE}/procurement/bids/portal-upload-prep`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload || {})
  })

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}

export async function requestVendorPortalUploadUrls(payload) {
  const response = await fetch(`${API_BASE}/procurement/bids/vendor-portal/upload-urls`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload || {})
  })

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}

export async function finalizeVendorPortalSubmission(payload) {
  const response = await fetch(`${API_BASE}/procurement/bids/vendor-portal/finalize`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload || {})
  })

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}

export async function requestVendorPortalAdUploadUrls(payload) {
  const response = await fetch(`${API_BASE}/procurement/bids/vendor-portal/ad-upload-urls`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload || {})
  })

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}

export async function finalizeVendorPortalAdDocuments(payload) {
  const response = await fetch(`${API_BASE}/procurement/bids/vendor-portal/ad-finalize`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload || {})
  })

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}
